export default __webpack_public_path__ + "611c1a423de5ad2d6871ee2e7d3c8536.png";